import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CertifiedEducationExamGroupFragment, StaticDataType } from "@ankaadia/graphql";
import { FieldType } from "@ngx-formly/core";
import { Card } from "primeng/card";
import { Observable, of } from "rxjs";
import { EducationExamService } from "../../features/education/education-exams/education-exam.service";
import { StaticDataPipe } from "../../shared/static-data/static-data.pipe";
import { NewUiFormlyCertifiedEducationExamsEntryComponent } from "./new-ui-formly-certified-education-exams-entry.component";

@Component({
  selector: "new-ui-formly-certified-education-exams",
  templateUrl: "./new-ui-formly-certified-education-exams.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Card, StaticDataPipe, NewUiFormlyCertifiedEducationExamsEntryComponent, AsyncPipe],
})
export class NewUiFormlyCertifiedEducationExamsComponent extends FieldType implements OnInit {
  readonly StaticDataType = StaticDataType;

  examGroups$: Observable<CertifiedEducationExamGroupFragment[]>;

  constructor(
    private readonly educationExamService: EducationExamService,
    private readonly changeDetector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.examGroups$ = this.formState.candidateId ? this.getCertifiedExamData() : of(null);
    this.changeDetector.detectChanges();
  }

  private getCertifiedExamData(): Observable<CertifiedEducationExamGroupFragment[]> {
    return this.educationExamService.getCertified(this.formState.candidateId, this.formState.organizationId);
  }
}
